<template>
  <div class="detail-ad" v-if="detail.adv && detail.adv.length">
    <div class="ad-container">
      <template v-for="(item, index) in detail.adv">
        <a v-if="index < 2" :key="index" :href="item.jump_url" class="item" target="_blank">
          <span>广告</span>
          <img :src="item.image" alt="" />
        </a>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "DetailAd",
  props: {
    detail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {}
};
</script>

<style lang="less" scoped>
.ad-container {
  margin-top: 10px;
  margin-bottom: 12px;
  a {
    display: block;
    position: relative;
    overflow: hidden;
    border-radius: 6px;

    & + a {
      margin-top: 8px;
    }

    span {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 5px;
      right: 5px;
      color: #fff;
      border: 1px solid #fff;
      background: rgba(255, 255, 255, 0.2);
      font-size: 12px;
      padding: 0 4px;
      border-radius: 2px;
      height: 18px;
    }

    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }
}
</style>
